<template>
  <a-breadcrumb
    class="breadcrumb"
    separator="|"
  >
    <a-breadcrumb-item
      v-if="routes.length === 2"
      style="font-size:18px"
    >
      {{ routes[1].name }}
    </a-breadcrumb-item>
    <a-breadcrumb-item
      v-if="routes.length === 2"
      style="font-size:14px;"
    >
      <router-link :to="routes[0].path">
        {{ routes[0].name }}
      </router-link>
      >
    </a-breadcrumb-item>
    <a-breadcrumb-item
      v-else
      style="font-size:18px"
    >
      {{ routes[0].name }}
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>
<script>
export default {
  data() {
    return {
      routes: this.$route.meta,
    };
  },
  mounted() {},
};
</script>
<style lang="scss">
.breadcrumb {
  font-size: 24px;
  font-weight: 600;
  color: rgba(86, 92, 102, 1);
  height: 70px;
  line-height: 70px;
}
</style>
